import { Tooltip } from 'antd'
import { Button, BUTTON_VARIANTS } from 'components/Button'
import { Bubble } from 'components/Bubble'
import { Input } from 'components/Input'
import { INPUT_VARIANTS } from 'components/Input/types'
import { Text } from 'components/Text'
import { useRouter } from 'next/router'
import { Wrapper } from 'styles/styleSystem/wrapper'
import { useLoginPage } from '../LoginPage/logic'
import { useEffect } from 'react'
import { SplashLoader } from 'components/SplashLoader'

export const LoginForm = ({ setSection = null, isAuthModal = false }) => {
  const {
    splashLoading,
    setSplashLoading,
    handleSubmit,
    handleEmailChange,
    handlePasswordChange,
    email,
    password,
    loading,
    error,
  } = useLoginPage()

  const loginDisabled = !email || !password
  const router = useRouter()
  const isSkipWaitlist = router.query.waitlist

  // Stops splash loader when the router to dashboard is complete
  useEffect(() => {
    if (splashLoading) {
      router.events.on('routeChangeComplete', () => setSplashLoading(false))
    }
  }, [splashLoading, router.events])

  if (splashLoading) {
    return <SplashLoader />
  }

  return (
    <form onSubmit={(e) => handleSubmit(e, isAuthModal)}>
      {error ? (
        <Wrapper mb={3}>
          <Bubble type="error" text={error} />
        </Wrapper>
      ) : null}
      <Wrapper spacing={15}>
        <div>
          <Input
            alt="email"
            variant={INPUT_VARIANTS.label}
            value={email}
            placeholder="user@gmail.com"
            onChange={handleEmailChange}
            label="Email"
          />
        </div>
        <Input
          alt="password"
          variant={INPUT_VARIANTS.label}
          value={password}
          type="password"
          placeholder="∗∗∗∗∗∗∗"
          onChange={handlePasswordChange}
          label="Password"
        />
      </Wrapper>
      <Wrapper mt={30}>
        <Tooltip title={loginDisabled ? 'Email or password empty' : null}>
          <div>
            <Button
              size="lg"
              fullWidth
              variant={BUTTON_VARIANTS.primary}
              label="Login"
              loading={loading}
              disabled={loginDisabled}
            />
          </div>
        </Tooltip>
      </Wrapper>
      <Wrapper
        mt={30}
        spacing={5}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        {!isSkipWaitlist ? (
          <>
            <Wrapper display="flex" alignItems="center" spacing={5} horizontal>
              <Text size="md" weight="light" color="secondary">
                Join Fintros Beta Waitlist?
              </Text>
              <Text hover weight="base" onClick={() => router.push('/')}>
                Request access.
              </Text>
            </Wrapper>
            <Wrapper display="flex" alignItems="center" spacing={5} horizontal>
              <Text size="md" weight="light" color="secondary">
                Already have a code?
              </Text>
              <Text hover weight="base" onClick={() => router.push('/join')}>
                Join here.
              </Text>
            </Wrapper>
          </>
        ) : (
          <Wrapper display="flex" alignItems="center" spacing={5} horizontal>
            <Text size="md" weight="light" color="secondary">
              Don&#39;t have an account?
            </Text>
            <Text
              hover
              weight="base"
              onClick={() =>
                setSection ? setSection('signup') : router.push('/join')
              }
            >
              Join Fintros.
            </Text>
          </Wrapper>
        )}
        <Wrapper display="flex" alignItems="center" spacing={5} horizontal>
          <Text size="md" weight="light" color="secondary">
            Are you an employer?
          </Text>
          <Text
            hover
            weight="base"
            onClick={() => router.push('https://beta.fintros.com')}
          >
            Login here.
          </Text>
        </Wrapper>
      </Wrapper>
      <Wrapper
        mt={1}
        mb={4}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Text
          hover
          size="md"
          weight="light"
          color="secondary"
          onClick={() =>
            setSection
              ? setSection('forgotPassword')
              : router.push('/forgot-password')
          }
        >
          Forgot password
        </Text>
      </Wrapper>
    </form>
  )
}
